export default "__VITE_ASSET__2ia7Su4x__"